<template>
    <div
        v-tooltip="tooltip"
        class="sg-custom-toggle sg-vrm-toggle sg-slide-colors"
        :class="{ 'sg-disabled': disabled, 'sg-with-tooltip': !!tooltip }"
    >
        <label :for="labelId">
            <input
                :id="labelId"
                type="checkbox"
                :disabled="disabled"
                :checked="!!value"
                @click="handleInput"
            />
            <div class="sg-alternative-display">
                <div class="sg-on" />
                <div class="sg-off" />
                <div class="sg-knob">
                    <div class="sg-dot" />
                </div>
            </div>
            <div class="sg-caption-container">
                <div class="sg-caption">
                    <slot>
                        <span class="sg-on">{{ on }}</span>
                        <span class="sg-off">{{ off }}</span>
                    </slot>
                </div>
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-controlled-toggle')
export default class VrmControlledToggle {
    @Prop({ type: Boolean, default: false })
    noColors;
    @Prop()
    on;
    @Prop()
    off;
    @Prop({ required: true })
    value;
    @Prop()
    disabled;
    @Prop({ type: Function, default: () => {} })
    ngToggle;

    @Prop({ type: String })
    tooltip;

    get labelId() {
        return `vrm_toggle_${this._uid}`;
    }

    handleInput(event) {
        event.preventDefault();
        this.$emit('input', event.target.checked);
        this.ngToggle(event.target.checked); // v-on seems to not be working in some cases, we'll use a passed function to trigger the change
    }
}
</script>
